import { React, Component } from "react";
import { InputGroup, FormControl, DropdownButton, ButtonGroup, Dropdown } from "react-bootstrap";
import Icons from "../../icon";
import ButtonIcon from "../../button";
import { ListTab } from "../list-tab/list-tab.component";
import FilterButton from "../filter-button/filter-button.component";
import DATEPICKER_OR from "../custom-form/custom-date-picker.component";
import { AddContractModal } from "../../internal/Finance/contract/modal/add-contract-modal.component";
import { AddAccountModal } from "../../internal/Finance/account/modal/account-modal.component";
import { AddCostCodeModal } from "../../internal/Finance/costcode/modal/cost-code-modal.component";
import { Header_Filter_Button_Label } from "../../../constants/internal-constants";
import { AddDisputeModal } from "../../internal/Finance/dispute/modal/dispute-add.component";
import { AddPlanModal } from "../../internal/Finance/ratecatalogue/modal/plan/add-plan-modal.component";
import { AddFeatureModal } from "../../internal/Finance/ratecatalogue/modal/feature/add-feature-modal.component";
import { AddRateModal } from "../../internal/Finance/ratecatalogue/modal/rate/add-rate-modal.component";
import { ListTabButton } from "../list-tab/list-tab-button.component";
import { ManageUserAccessModal } from "../../internal/administration/modal/manage-user-access/manage-user-access-modal";
import "./header-filter.component.css";
import { ManageUserRoleModal } from "../../internal/administration/modal/manage-user-access/manage-user-rule";
import { ManageVendorModal } from "../../internal/administration/modal/manage-vendor/manage-vendor-modal.component";
import { UploadModal } from "../upload/upload.component";
export class HeaderFilter extends Component {
    constructor(props) {
        super(props);
        this.state={
            tabName:"",
            startDate:null
        }
        this.refreshPage = this.refreshPage.bind(this);
    }

    selectedTab=(clickTab)=> {
        this.setState({tabName:clickTab}); 
    }

    componentDidMount() {      
        window.addEventListener("load", this.refreshPage);       
    }

    componentWillUnmount() { 
        window.removeEventListener('load', this.refreshPage)  
      }

    refreshPage() {
        var tabActive = document.querySelectorAll(".request-table.data-table .list-tab.isSelectedTab");
        if(tabActive.length!==0)
        {
            this.setState({tabName:tabActive[0].innerText});
        }       
    }
    
    addButtonTitle({btnAddTitle}) {       
        switch (btnAddTitle) {
            case Header_Filter_Button_Label.AddContract:
              return <AddContractModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddAccount:
              return <AddAccountModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddCostCode:
              return <AddCostCodeModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddDispute:
              return <AddDisputeModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddPlan:
              return <AddPlanModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddFeature:
              return <AddFeatureModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddRate:
              return <AddRateModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddUserAccess:
                return <ManageUserAccessModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle}  />;
            case Header_Filter_Button_Label.AddUserRole:
                return <ManageUserRoleModal  labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
            case Header_Filter_Button_Label.AddNewVendor:
                return <ManageVendorModal labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />
            default:
              return <ButtonIcon onClick={()=>alert("click")} iconLeft="file-plus" iconSize="17px" customClassName="header-filter-button" labelName={this.props.haveTab ? "Add " + this.props.listSelected : btnAddTitle} />;
          }
    }

    buttonList(){       
        if(this.props.enableExportExcel) {
            return <div className="header-filter-button-container">
                 <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
            </div>
        }
        
        if(this.props.enableUploadBtn) {
            return <div className="header-filter-button-container">
                <ButtonIcon onClick={()=>alert("click")} iconLeft="upload" iconSize="17px" customClassName="header-filter-button" labelName="Upload a File"/>
            </div>
        }
    }

    render(){
        const {haveHeaderButton, dropdownItem, enableDatePicker, enableExportExcel, filterData, filtersub, enableAddBtn, enableUploadBtn, enableDropdown, listItem, haveTab, btnAddTitle, enableFilterBtn, enableExtractBtn, enableAddressBtn}= this.props;
  
        return(
            <>
            {haveTab && <ListTabButton listData={listItem} selectedIndex={this.props.selectedIndex} filterList={this.props.filterList} FilterIndex={this.props.FilterIndex}/> }
             
            {haveHeaderButton &&
                <div className="header-button-container">
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-pdf" iconSize="17px" customClassName="header-filter-button" labelName="Export to PDF"/> 
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="upload" iconSize="17px" customClassName="header-filter-button" labelName="Upload a File"/> 
                </div>               
            }       
            <div className="header-filter-container">                 
               <div className="left-container">
                <InputGroup size="sm" className="request-input-header">              
                    <InputGroup.Text id="inputGroup-sizing-sm">
                        <Icons name="search" customClassName="icon-search" size="16px" />
                    </InputGroup.Text>
                    <FormControl
                        onKeyPress={this.props.searchAction}
                        placeholder="Search..."
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                    />   
                </InputGroup>  
                    {enableFilterBtn &&
                        <div className="header-filter-button-container">
                             <FilterButton filterData={filterData} filtersub={filtersub}/>   
                        </div>
                    }

                {enableDropdown &&
                    <DropdownButton
                    as={ButtonGroup}                           
                    title={dropdownItem !== undefined ? dropdownItem[0] : "" }
                    id="bg-vertical-dropdown-2"
                    className="subscription-price-btn"
                    >
                        {dropdownItem!==undefined ? dropdownItem.map((item,id)=>
                            <Dropdown.Item eventKey={id} key={id}>{item}</Dropdown.Item>
                        ): ""}                      
                    </DropdownButton>  
                }                
            
            
                {enableExportExcel &&
                    <div className="header-filter-button-container">
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
                    </div>
                }

                {enableAddBtn &&
                        <div className="header-filter-button-container upload-component">
                            {
                               this.addButtonTitle({btnAddTitle})       
                            }
                        </div>
                }

                {enableAddressBtn &&
                    <div className="header-filter-button-container">
                        <ButtonIcon onClick={()=>alert("click")} iconLeft="address-book" iconSize="17px" customClassName="header-filter-button" labelName="Extract Phonebook"/>
                    </div>
                }  

                {enableExtractBtn && 
                        <div className="header-filter-button-container">
                            <ButtonIcon onClick={()=>alert("click")} iconLeft="download" iconSize="17px" customClassName="header-filter-button" labelName="Extract All"/>
                        </div>
                }  
                {enableUploadBtn &&
                        <div className="header-filter-button-container">
                            <UploadModal />
                        </div>
                }  

                {
                    enableDatePicker && 
                            <DATEPICKER_OR label="SELECT DATE" startDate={this.state.startDate} dateSelected={this.state.startDate} selectedDate={(date) => this.setState({startDate:date})}/>
                
                }
               </div> 
            </div>     
           
            </>
        )
    }
}